import { configureStore } from '@reduxjs/toolkit';
import currentUserReducer from './CurrentUserReducer/currentUserSlice';
import searchedUserReducer from './SearchedUserReducer/searchedUserSlice';
import skillsReducer from './SkillReducer/skillSlice';
import eligibilityReducer from './EligibilityReducer/eligibilitySlice';
import siteDetailsReducer from './SiteDetailsReducer/siteDetailsSlice';
import shiftTimeReducer from './ShiftTimeReducer/shiftTimeSlice';
import registrationReducer from './RegistrationReducer/registrationSlice';
import teamReducer from './TeamReducer/teamSlice';
import availableShiftsReducer from './AvailableShiftsReducer/availableShiftsSlice';
import pendingShiftsReducer from './PendingShiftsReducer/pendingShiftsSlice';
import myShiftsReducer from './MyShiftsReducer/myShiftsSlice';
import grabShiftReducer from './GrabShiftReducer/grabShiftSlice';
import decisionShiftReducer from './DecisionShiftReducer/decisionShiftSlice';
import authReducer from './AuthReducer/authSlice';
import supervisorReducer from './SupervisorReducer/supervisorSlice';
import kpiReducer from './KpiReducer/kpiSlice';
import calendarReportReducer from './CalendarReportReducer/calendarReportSlice';
import tableReportReducer from './TableReportReducer/tableReportSlice';
import dashboardReportReducer from './DashboardReportReducer/dashboardReportSlice';
import passwordResetReducer from './PasswordResetReducer/passwordResetSlice';
import profileAdminSummaryReducer from './ProfileAdminSummaryReducer/profileAdminSummarySlice';
import workdaySyncReportReducer from './WorkdaySyncReportReducer/workdaySyncReportSlice';
import gigShiftReducer from './GigShiftReducer/gigShiftSlice';
import gigRequestShiftReducer from './GigRequestShiftReducer/gigRequestShiftSlice';
import gigRequestsReducer from './GigRequestsReducer/gigRequestsSlice';
import gigMyRequestsReducer from './GigMyRequestsReducer/gigMyRequestsSlice';
import gigPostUnfilledReducer from './GigPostUnfilledReducer/gigPostUnfilledSlice';
import gigCalendarReducer from './GigCalendarReducer/gigCalendarSlice';
import gigShiftSettingsReducer from './GigShiftSettingsReducer/gigShiftSettingsSlice';
import gigReportReducer from './GigReportReducer/gigReportSlice';

// Create the Redux store based on Redux Toolkit
const store = configureStore({
  reducer: {
    currentUser: currentUserReducer,                // Current logged-in user
    searchedUser: searchedUserReducer,              // Searched employee
    skills: skillsReducer,
    eligibility: eligibilityReducer,
    siteDetails: siteDetailsReducer,
    shiftTime: shiftTimeReducer,
    registration: registrationReducer,
    teams: teamReducer,
    login: authReducer,                             // Authentication state (loading, error)
    availableShifts: availableShiftsReducer,        // Available shifts for the site
    grabShift: grabShiftReducer,                    // Grab/claim a shift
    calendarReport: calendarReportReducer,          // Calendar report data
    pendingShifts: pendingShiftsReducer,            // Pending shifts awaiting supervisor approval
    myShifts: myShiftsReducer,                      // Current user's claimed shifts
    decisionShift: decisionShiftReducer,            // Approve or reject a pending shift claim
    supervisors: supervisorReducer,                 // Supervisors for approve/reject dropdown
    kpi: kpiReducer,                                // KPI report data
    tableReport: tableReportReducer,                // Table report data
    dashboardReport: dashboardReportReducer,        // Dashboard report data
    passwordReset: passwordResetReducer,            // Password reset actions and state
    profileAdminSummary: profileAdminSummaryReducer,// Admin employee profile summary data
    workdaySyncReport: workdaySyncReportReducer,    // Workday sync report data
    gigShift: gigShiftReducer,                      // GIG shift group decisions & updates (stub)
    gigRequestShift: gigRequestShiftReducer,        // Submit a gig shift request (POST /api/gig/requestShift)
    gigRequests: gigRequestsReducer,                // Gig shift requests (GET /api/gig/requests, PUT /api/gig/update)
    gigMyRequests: gigMyRequestsReducer,            // Current gig worker's own requests (GET /api/gig/myRequests)
    gigPostUnfilled: gigPostUnfilledReducer,        // Post unfilled shifts to broad gig teams (POST /api/gig/postUnfilled)
    gigCalendar: gigCalendarReducer,                // Gig calendar data for a site (GET /api/gig/calendar)
    gigShiftSettings: gigShiftSettingsReducer,      // Gig cutoff reminder settings
    gigReport: gigReportReducer,                    // Gig shift report metrics (GET /api/reports/gig)
  }
});

// Defines the shape of your entire Redux state
export type RootState = ReturnType<typeof store.getState>;

// Defines the type of your dispatch function
export type AppDispatch = typeof store.dispatch;

export default store;




